import React, { useMemo } from 'react';
import { Card, Col, Row } from 'antd';

function cleanReportText(text) {
  if (!text) return '';
  const lines = text.split('\n');
  const cleaned = lines.filter((line) => {
    const t = line.trim();
    if (!t) return true;
    if (/Calibri|Times New Roman|@PB/i.test(t)) return false;
    const junkChars = (t.match(/[{}|~^$\\`#@[\]_]/g) || []).length;
    if (junkChars >= 2) return false;
    if (/^[0-9a-f_\-]+$/i.test(t)) return false;
    return true;
  });
  return cleaned.join('\n').replace(/\n{3,}/g, '\n\n').trim();
}

const reportStyle = {
  fontFamily: "'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  fontSize: 13,
  fontWeight: 600,
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
  lineHeight: 1.8,
  overflow: 'auto',
  color: '#2c3e50',
};

const SideBySide = ({ leftTitle, rightTitle, leftContent, rightContent }) => {
  const cleanLeft = useMemo(() => cleanReportText(leftContent), [leftContent]);
  const cleanRight = useMemo(() => cleanReportText(rightContent), [rightContent]);

  return (
    <Row gutter={16} style={{ display: 'flex', alignItems: 'stretch' }}>
      <Col xs={24} lg={12} style={{ display: 'flex' }}>
        <Card
          title={leftTitle}
          size="small"
          style={{ borderRadius: 14, border: 'none', boxShadow: '0 1px 4px rgba(26,60,122,0.08)', flex: 1, display: 'flex', flexDirection: 'column' }}
          headStyle={{ backgroundColor: '#D6E4F7', fontWeight: 600, color: '#1A3C7A', border: 'none', borderRadius: '14px 14px 0 0' }}
          bodyStyle={{ flex: 1, background: '#F7F9FC', borderRadius: '0 0 14px 14px', padding: 16 }}
        >
          <div style={reportStyle}>{cleanLeft || 'No content available'}</div>
        </Card>
      </Col>
      <Col xs={24} lg={12} style={{ display: 'flex' }}>
        <Card
          title={rightTitle}
          size="small"
          style={{ borderRadius: 14, border: 'none', boxShadow: '0 1px 4px rgba(26,60,122,0.08)', flex: 1, display: 'flex', flexDirection: 'column' }}
          headStyle={{ backgroundColor: '#1A3C7A', fontWeight: 600, color: '#fff', border: 'none', borderRadius: '14px 14px 0 0' }}
          bodyStyle={{ flex: 1, background: '#F7F9FC', borderRadius: '0 0 14px 14px', padding: 16 }}
        >
          <div style={reportStyle}>{cleanRight || 'No content available'}</div>
        </Card>
      </Col>
    </Row>
  );
};

export default SideBySide;
